export default __webpack_public_path__ + "9dc1e1a5c77907481191e7f14854dcf6.svg";